import { errorView, useCurrentDay, useOpenWindow, useWindow } from '@krp/client-runtime'
import {
  PlacesScreen,
  SCHEDULE_WINDOWS,
  cashiersByPlace,
  combinedView,
  monthOfDay,
  scheduleAccess,
  scheduleAssignmentsAll,
  schedulePlaces,
  type PlacesActions,
  type PlacesVm,
} from '@krp/schedule-ui'

import { viewOf } from './scheduleKit'

/**
 * «График выхода» — вход раздела: плитки объектов. Объекты и права — в кэше запросов. Нажатие на плитку открывает таблицу
 * графика объекта за текущий месяц; создание и правка объекта — окна поверх экрана. «Сегодня выходят» на плитках — один запрос назначений
 * всех объектов на сегодня; если он не прочитался, счётчиков нет, а причина показана на экране.
 */
export function ScheduleHomeBinding() {
  const openWindow = useOpenWindow()
  const today = useCurrentDay()
  const access = scheduleAccess.useQuery()
  const places = schedulePlaces.useQuery({ includeArchived: false })
  const { replaceWith } = useWindow()
  const todayAssignments = scheduleAssignmentsAll.useQuery({ from: today, to: today })

  const load = combinedView([viewOf(access), viewOf(places)])
  const sorted = [...(places.data ?? [])].sort((left, right) => left.sortOrder - right.sortOrder || left.name.localeCompare(right.name, 'ru'))

  const vm: PlacesVm = {
    load,
    refreshing: load.refreshing,
    canManage: access.data?.canManage === true,
    places: sorted,
    todayCounts: todayAssignments.isError || todayAssignments.currentData === undefined ? null : cashiersByPlace(todayAssignments.currentData),
    todayError: todayAssignments.isError ? errorView(todayAssignments.error) : null,
  }
  const actions: PlacesActions = {
    openPlace: (placeId) => openWindow(SCHEDULE_WINDOWS.place, { placeId, month: monthOfDay(today) }),
    editPlace: (placeId) => openWindow(SCHEDULE_WINDOWS.editPlace, { placeId }),
    createPlace: () => openWindow(SCHEDULE_WINDOWS.newPlace),
    openCashiers: () => replaceWith(SCHEDULE_WINDOWS.cashiers, { month: monthOfDay(today) }),
    reload: () => {
      void access.refetch()
      void places.refetch()
      void todayAssignments.refetch()
    },
  }
  return <PlacesScreen vm={vm} actions={actions} />
}
